var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2.14844C6.49 2.14844 2 6.63844 2 12.1484C2 17.6584 6.49 22.1484 12 22.1484C17.51 22.1484 22 17.6584 22 12.1484C22 6.63844 17.51 2.14844 12 2.14844ZM16.78 9.84844L11.11 15.5184C10.97 15.6584 10.78 15.7384 10.58 15.7384C10.38 15.7384 10.19 15.6584 10.05 15.5184L7.22 12.6884C6.93 12.3984 6.93 11.9184 7.22 11.6284C7.51 11.3384 7.99 11.3384 8.28 11.6284L10.58 13.9284L15.72 8.78844C16.01 8.49844 16.49 8.49844 16.78 8.78844C17.07 9.07844 17.07 9.54844 16.78 9.84844Z",
    fill: "#15D43F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.71f5a8b5.svg";
export { ForwardRef as ReactComponent };